var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SuiteRentals"}},[_c('HeroSlider',{attrs:{"sliderImages":_vm.sliderImages}}),_c('section',{attrs:{"id":"suites"}},[_c('Suites')],1),_c('section',{attrs:{"id":"schedule-section"}},[_c('Schedule')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }